import { motion } from "framer-motion";
import { usePublicData } from "../../context/PublicDataContext";

const item = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export const GiftServices = () => {
  const { categories } = usePublicData();
  return (
    <section
      id="gifts"
      className="relative py-24 md:py-32 bg-[#0b1221] overflow-hidden"
      data-testid="gifts-section"
    >
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#0033FF]/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-2xl mb-16">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-sm font-semibold text-[#6b8bff] uppercase tracking-widest mb-3"
          >
            Gift Services
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-display font-extrabold tracking-tighter text-4xl md:text-5xl text-white"
          >
            Make every occasion unforgettable.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-4 text-white/60 text-lg"
          >
            Hand-picked gifts, wrapped with care and delivered right on time.
          </motion.p>
        </div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          transition={{ staggerChildren: 0.05 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
        >
          {categories.map((g, i) => {
            const wide = i === 0 || i === 7;
            return (
              <motion.div
                key={g.title}
                variants={item}
                className={`group relative rounded-2xl p-6 bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 hover:border-[#0033FF]/50 transition-[background,border-color,transform] duration-300 hover:-translate-y-1 ${
                  wide ? "sm:col-span-2 lg:col-span-2" : ""
                }`}
                data-testid={`gift-card-${i}`}
              >
                <span className="inline-flex w-16 h-16 rounded-2xl overflow-hidden ring-1 ring-white/15 mb-5 group-hover:scale-110 transition-transform duration-300">
                  <img
                    src={g.image}
                    alt={g.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover"
                  />
                </span>
                <h3 className="font-display font-semibold text-white text-lg">
                  {g.title}
                </h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
